import { render, staticRenderFns } from "./HistorySubject.vue?vue&type=template&id=4bcaaf0d"
import script from "./HistorySubject.vue?vue&type=script&lang=js"
export * from "./HistorySubject.vue?vue&type=script&lang=js"
import style0 from "./HistorySubject.vue?vue&type=style&index=0&id=4bcaaf0d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports